/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/**
 * 首页数据服务层
 * 负责管理和加工所有组件的API数据
 */
import { ubtSendError } from '@/shared/utils/ubt';
import { getIncreaseCreditInfo as getIncreaseCreditInfoApi } from '@/api/increase-credit/increase-credit-zone';
import type { IncreaseCreditInfoType } from '@/api/increase-credit/increase-credit-zone/types';
import { isCallback as getEquityRecallInfo } from '@/api/rights';
import type { CallbackType } from '@/api/rights/types';
import { getAdvData } from '@/components/adv-components/adv-common-api';
import { appEnv } from '@/components/adv-components';
import { analyzeFinanceCardAdvData } from '@/views_v2/home/const';
import { advMasterApi } from '@hb/h5-components';
import type { Ref } from '@vue/composition-api';
import { getMiddleIncomeData } from '@/api/homepage';
import { HOME_ADV_ID_MAP } from './constant';
import type { MarketBannerAdvData, MiddleIncomeData } from './types';

/** 请求提额专区信息数据 */
export const getIncreaseCreditInfo = async ():
  Promise<IncreaseCreditInfoType | undefined> => {
  try {
    const { adjustAuthList = [], carLoanList = [] } = await getIncreaseCreditInfoApi() || {};

    if (adjustAuthList?.length > 0 || carLoanList?.length > 0) {
      return {
        adjustAuthList: adjustAuthList.slice(0, 2), // 限制显示前2条
        carLoanList,
      };
    }
  } catch (error) {
    ubtSendError(error as Error);
  }

  return undefined;
};

/** 请求权益召回数据 */
export const getEquityRecallData = async (): Promise<CallbackType | undefined> => {
  try {
    return await getEquityRecallInfo();
  } catch (error) {
    ubtSendError(error as Error);
  }

  return undefined;
};

/** 请求金融卡片-营销banner广告位数据 */
export const getMarketBannerAdv = async (): Promise<MarketBannerAdvData | undefined> => {
  try {
    const advResult = await advMasterApi.getBannerInfos(
      HOME_ADV_ID_MAP.FINANCE_CARD_ADV_BANNER,
      appEnv,
      {},
    );

    const result = analyzeFinanceCardAdvData(advResult);

    const {
      marketSource, marketHeight, marketWidth = '', marketUrl = '',
    } = result;

    if (marketSource && marketHeight) {
      return {
        marketSource,
        marketHeight,
        marketWidth,
        marketUrl,
      };
    }
  } catch (error) {
    ubtSendError(error as Error);
  }

  return undefined;
};


/** 请求中收首页数据 */
export const getMiddleIncome = async (): Promise<MiddleIncomeData | undefined> => {
  try {
    const data = await getMiddleIncomeData('finance_shopMall_home');
    return data;
  } catch (error) {
    ubtSendError(error as Error);
  }
  return undefined;
};
/**
* 异步赋值辅助函数
* 用于简化异步数据赋值到 Vue ref 的操作
*/
export const assignAsync = <T>(ref: Ref<T>, resultPromise: Promise<T>)
  : Promise<void> => resultPromise.then((res) => { ref.value = res; });

export {
  IncreaseCreditInfoType,
  CallbackType,
};
